import React from 'react';
import { css } from 'aphrodite';
import styles from '../button-styles';
import '../button-loading-styles.css';
import obStyles from './orange-button-styles';
import { withRouter } from 'react-router-dom';
import buttonClick from '../button-click';

const OrangeButton = (props) => (
  <div className={css(styles.root, obStyles.root, props.loading && styles.rootLoading, props.disabled && styles.rootDisabled)} onClick={buttonClick(props)}>
    <div className={css(styles.title, obStyles.title, props.loading && styles.titleLoading)}>{props.title}</div>
    {props.loading && <div className={'loading'} style={{ position: 'absolute', top: 3, texAlign: 'center' }}>
      <span>.</span><span>.</span><span>.</span>
    </div>}
  </div>
);

export default withRouter(OrangeButton);



// WEBPACK FOOTER //
// ./src/components/common/button/orange-button/orange-button.js